export const DEFAULT_MSAPP_CONFIG = 'none';
export const DEFAULT_MSAPP_TILE_SMALL =
  'https://d26q4asbryw2nm.cloudfront.net/2390803/bundles/sahapp/favicon/smalltile.png';
export const DEFAULT_MSAPP_TILE_MEDIUM =
  'https://d26q4asbryw2nm.cloudfront.net/2390803/bundles/sahapp/favicon/mediumtile.png';
export const DEFAULT_MSAPP_TILE_WIDE =
  'https://d26q4asbryw2nm.cloudfront.net/2390803/bundles/sahapp/favicon/widetile.png';
export const DEFAULT_MSAPP_TILE_LARGE =
  'https://d26q4asbryw2nm.cloudfront.net/2390803/bundles/sahapp/favicon/largetile.png';

const DEFAULT_PROPERTIES = {
  config: DEFAULT_MSAPP_CONFIG,
  tileSmall: DEFAULT_MSAPP_TILE_SMALL,
  tileMedium: DEFAULT_MSAPP_TILE_MEDIUM,
  tileWide: DEFAULT_MSAPP_TILE_WIDE,
  tileLarge: DEFAULT_MSAPP_TILE_LARGE
};

const PROPERTIES_MAP = {
  validate: 'msvalidate.01',
  config: 'msapplication-config',
  tileSmall: 'msapplication-square70x70logo',
  tileMedium: 'msapplication-square150x150logo',
  tileWide: 'msapplication-wide310x150logo',
  tileLarge: 'msapplication-square310x310logo'
};

export function createMsAppMetas(props = {}) {
  const mergedProps = { ...DEFAULT_PROPERTIES, ...props };
  const allowedKeys = Object.keys(PROPERTIES_MAP);

  return allowedKeys
    .filter(key => typeof mergedProps[key] !== 'undefined')
    .reduce(
      (acc, key) => [
        ...acc,
        {
          name: PROPERTIES_MAP[key],
          content: mergedProps[key]
        }
      ],
      []
    );
}

export default {
  createMsAppMetas,
  DEFAULT_MSAPP_CONFIG,
  DEFAULT_MSAPP_TILE_SMALL,
  DEFAULT_MSAPP_TILE_MEDIUM,
  DEFAULT_MSAPP_TILE_WIDE,
  DEFAULT_MSAPP_TILE_LARGE
};
